// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unit-conversion-table[data-v-2d66deb4]{padding:30px}@media only screen and (max-width: 768px){.unit-conversion-table[data-v-2d66deb4]{padding:20px}}.unit-conversion-table h3[data-v-2d66deb4]{font-weight:600;font-size:1.375em;margin-bottom:30px}.unit-conversion-table table[data-v-2d66deb4]{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
